import React from 'react';
import { useBooking } from '../../../../../../../contexts/ticketBookingContext/TicketBookingContext';
import ChooseSeatsNavigation from '../../../bookingNavigationSteps/ChooseSeatsNavigation';
import cancelSeatReserve from '../../../../../../../../utils/functions/cancelSeatReserve';
import FillPassengersNavigation from '../../../bookingNavigationSteps/FillPassengersNavigation';

function SelectNavigationTabItems() {
  const {
    departureChosenSeats,
    ridesCarriagesInfo,
    bookingData,
    setDepartureChosenSeats,
    departurePassengersForm,
    returnChosenSeats,
    setReturnChosenSeats,
    returnPassengersForm,
    statement,
  } = useBooking();
  const isReturnWay = Boolean(bookingData?.return?.id);

  return [{
    key: 1,
    children: <ChooseSeatsNavigation
      showPrice={ridesCarriagesInfo?.departure?.route_type !== 'international'}
      departureChosenSeats={departureChosenSeats}
      returnChosenSeats={returnChosenSeats}
      cancelDepartureReservedSeat={async (seat, wagonNumber) => {
        await cancelSeatReserve(
          ridesCarriagesInfo?.departure,
          ridesCarriagesInfo?.statement,
          setDepartureChosenSeats,
          seat,
          wagonNumber,
        );
      }}
      cancelReturnChosenSeats={async (seat, wagonNumber) => {
        await cancelSeatReserve(
          ridesCarriagesInfo?.return,
          ridesCarriagesInfo?.statement,
          setReturnChosenSeats,
          seat,
          wagonNumber,
        );
      }}
    />,
  }, {
    key: isReturnWay ? 2 : 100,
    children: <ChooseSeatsNavigation
      showPrice={ridesCarriagesInfo?.return?.route_type !== 'international'}
      departureChosenSeats={departureChosenSeats}
      returnChosenSeats={returnChosenSeats}
      cancelDepartureReservedSeat={async (seat, wagonNumber) => {
        await cancelSeatReserve(
          ridesCarriagesInfo?.departure,
          ridesCarriagesInfo?.statement,
          setDepartureChosenSeats,
          seat,
          wagonNumber,
        );
      }}
      cancelReturnChosenSeats={async (seat, wagonNumber) => {
        await cancelSeatReserve(
          ridesCarriagesInfo?.return,
          ridesCarriagesInfo?.statement,
          setReturnChosenSeats,
          seat,
          wagonNumber,
        );
      }}
    />,
  }, {
    key: isReturnWay ? 3 : 2,
    children: <FillPassengersNavigation
      showMobile
      departureForm={departurePassengersForm}
    />,
  }, {
    key: isReturnWay ? 4 : 3,
    children: isReturnWay ? (
      <FillPassengersNavigation
        showMobile
        departureForm={departurePassengersForm}
        returnForm={returnPassengersForm}
      />
    )
      : (
        <FillPassengersNavigation
          showMobile
          statement={statement}
        />
      ),
  }, {
    key: isReturnWay ? 5 : 4,
    children: <FillPassengersNavigation
      statement={statement}
      showMobile
    />,
  },
  ];
}

export default SelectNavigationTabItems;
